import React, { memo, useState } from "react";
import LazyLoad from "react-lazyload";
import PasswordReset from "../components/Auth/PasswordReset"; //  path to password Reset component
import RegisterForm from "../components/Auth/RegisterForm";

const RegisterPage = () => {
  const [forgotPassword, setForgotPassword] = useState(false);
  return (
    <div className="login-container">
      {/* Left and right side content (styling classes not provided) */}
      <div className="left-side">
        <LazyLoad height={20} offset={100}>
          <img
            src={"/Saly-1.png"}
            alt="Left"
            style={{
              width: "100%",
              height: "100vh",
              objectFit: "cover",
            }}
          />
        </LazyLoad>
      </div>
      {forgotPassword ? (
        <PasswordReset
          setForgotPassword={setForgotPassword}
          forgotPassword={forgotPassword}
        />
      ) : (
        <RegisterForm />
      )}
    </div>
  );
};

export default memo(RegisterPage);
